import gql from 'graphql-tag';

export const GET_ALL_TAX_LIST = gql`
query(
    $golf_group_code: String
    $golf_code: String
    $limit_rows: Int
    $begin_row: Int
    $tax_id: ID
){
    GetTaxListByPlanMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        limit_rows: $limit_rows
        begin_row: $begin_row
        tax_id: $tax_id
    ){
        TaxMasterList{
            id
            golf_code
            golf_group_code
            tax_id
            start_date
            tax_division
            tax
            valid_flag
        }
        latestStartDate
        count
    }
}
`;

export const REGISTER_TAX_MASTER = gql`
  mutation(
    $golf_group_code: String
    $golf_code: String
    $tax_id: String
    $start_date: String
    $tax_name: String
    $tax_division: Int
    $tax: String
  ){
    RegisterTaxMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        tax_id: $tax_id
        start_date: $start_date
        tax_name: $tax_name
        tax_division: $tax_division
        tax: $tax
  ){
    result
  }
}
`;

export const UPDATE_TAX_MASTER = gql`
  mutation(
    $golf_group_code: String
    $golf_code: String
    $tax_id: String
    $start_date: String
    $tax_name: String
    $tax_division: Int
    $tax: String
    $old_tax_id: String
    $old_start_date: String
    $id: Int
  ){
    UpdateTaxMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        tax_id: $tax_id
        start_date: $start_date
        tax_name: $tax_name
        tax_division: $tax_division
        tax: $tax
        old_tax_id: $old_tax_id
        old_start_date: $old_start_date
        id: $id
  ){
    result
  }
}
`;

export const GET_SELECT_TAX_LATEST_DATE = gql`
query(
    $golf_group_code: String
    $golf_code: String
    $tax_id: String
){
    GetSelectTaxLatestDate(
          golf_group_code: $golf_group_code
          golf_code: $golf_code
          tax_id: $tax_id
    ){
        latest_start_date
    }
  }
`;
